import { render, staticRenderFns } from "./ProjectAccountTotalBox.vue?vue&type=template&id=7bcd9e9a&scoped=true"
import script from "./ProjectAccountTotalBox.vue?vue&type=script&lang=ts"
export * from "./ProjectAccountTotalBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcd9e9a",
  null
  
)

export default component.exports